"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOL_TIP_DELAY = void 0;
var TOOL_TIP_DELAY = exports.TOOL_TIP_DELAY = {
  show: 500,
  hide: 0
};